import { addDays, format, getHours, isToday, subDays, endOfDay } from "date-fns";
import { RentalPointName } from "./RentalPointName";
import { GeneralDelivery } from "./GeneralDelivery";

export class RentalPointDelivery extends GeneralDelivery{

    protected rentalPoints = [
        {id: RentalPointName.BEERSE, name: "Beerse"},
        {id: RentalPointName.BRUGGE, name: "Brugge"},
        {id: RentalPointName.GHENT, name: "Gent"},
        {id: RentalPointName.HASSELT, name: "Hasselt"},
        {id: RentalPointName.HERENT, name: "Herent"},
        {id: RentalPointName.MERKSEM, name: "Merksem"},
        {id: RentalPointName.AALST, name: "Aalst"},
        {id: RentalPointName.BRUSSEL, name: "Brussel"},
        {id: RentalPointName.POELKAPELLE, name: "Poelkapelle"}
    ];

    public earliestDeliveryDateAfter(date: Date) {
        if (isToday(date) && getHours(date) < 16 && this.holidaysManager.isOurRentalPointWorking(date)) {
            return date;
        }
        let possibleDate = addDays(date, 1);

        while (!this.holidaysManager.isAnyRentalPointWorking(possibleDate)) {
            possibleDate = addDays(possibleDate, 1);
        }
        return possibleDate;
    }

    protected findPointWorkingDateByCallback(point: number, date: Date, modifierFn: (date: Date, days: number) => Date) {
        let possibleDate = modifierFn(date, 1);

        while (!this.holidaysManager.isRentalPointWorking(point, possibleDate)) {
            possibleDate = modifierFn(possibleDate, 1);
        }
        return possibleDate;
    }

    public findPointNextWorkingDate(point: number, date: Date) {
        return this.findPointWorkingDateByCallback(point, date, addDays);
    }

    public findPointNextReturnDate(point: number, date: Date) {
        const potentialDate = this.findPointNextWorkingDate(point, date);
        const friday = 5;
        
        // TODO: Refactor so that it reuses the `isWorkingReturnDate` function
        //       from RentalPointDatesSelector.tsx
        if (point === RentalPointName.BEERSE && potentialDate.getDay() === friday) {
            return this.findPointNextWorkingDate(point, addDays(potentialDate, 1));
        } else {
            return potentialDate;
        }
    }


    public findPointPreviousWorkingDate(point: number, date: Date) {
        return this.findPointWorkingDateByCallback(point, date, subDays);
    }


    public getPlayDatesForAllPoints(playStart: Date, playEnd: Date) {
        return this.rentalPoints.map((rentalPoint) => {
            return {
                point: rentalPoint.id,
                startDate: format(this.findPointPreviousWorkingDate(rentalPoint.id, playStart), "yyyy-MM-dd"),
                endDate: format(this.findPointNextReturnDate(rentalPoint.id, playEnd), "yyyy-MM-dd")
            };
        });
    }

    public getPlayDatesForOurPoints(playStart: Date, playEnd: Date) {
        return this.rentalPoints.filter((point) => {
            return point.id === RentalPointName.HERENT || point.id === RentalPointName.HASSELT;
        }).map((rentalPoint) => {
            return {
                point: rentalPoint.id,
                startDate: format(this.findPointPreviousWorkingDate(rentalPoint.id, playStart), "yyyy-MM-dd"),
                endDate: format(this.findPointNextReturnDate(rentalPoint.id, playEnd), "yyyy-MM-dd")
            };
        });
    }
}
